import { render, staticRenderFns } from "./zzl-report.vue?vue&type=template&id=6f82b5c8&scoped=true"
import script from "./zzl-report.vue?vue&type=script&lang=js"
export * from "./zzl-report.vue?vue&type=script&lang=js"
import style0 from "./zzl-report.vue?vue&type=style&index=0&id=6f82b5c8&prod&scoped=true&lang=less"
import style1 from "./zzl-report.vue?vue&type=style&index=1&id=6f82b5c8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f82b5c8",
  null
  
)

export default component.exports